import PlatBombee from 'assets/img/plat-bombe.png';
import SansPlatBombee from 'assets/img/sans-plat-bombe.png';

import Bobines2 from 'assets/img/2-bobines.png';
import Bobines4 from 'assets/img/4-bobines.png';
import Bobines6 from 'assets/img/6-bobines.png';
import Bobines8 from 'assets/img/8-bobines.png';

import PoseApplique from 'assets/img/pose-en-applique.png';

import PoseEncastre from 'assets/img/pose-encastre.png';

import PoseTunnel from 'assets/img/pose-en-tunnel.png';
import LameCobra from 'assets/img/lame-cobra.png';
import LameMicroperforee from 'assets/img/lame-micro-perforee.png';
import LamePleine from 'assets/img/lame-pleine.png';
import LamePolycarbonate from 'assets/img/lame-polycarbonate.png';
import { default as BoiteBip, default as BoiteBouton } from 'assets/img/boite-bouton.png';
import CableDebrayage from 'assets/img/boite-cable-debrayage.png';
import BoiteCleCableDebrayage from 'assets/img/boite-cle-cable-debrayage.png';
import BoiteCle from 'assets/img/boite-cle.png';
import EnroulementExterieur from 'assets/img/enroulement-exterieur.png';
import EnroulementInterieur from 'assets/img/enroulement-interieur.png';
import MoteurCentrale from 'assets/img/rideau-moteur-centrale.png';
import MoteurLaterale from 'assets/img/rideau-moteur-laterale.png';
import MoteurTubulaire from 'assets/img/rideau-moteur-tubulaire.png';

import Axe133 from 'assets/img/axe-133.png';
import Axe168 from 'assets/img/axe-168.png';
import Axe50 from 'assets/img/axe-50.png';
import Axe60 from 'assets/img/axe-60.png';
import Axe76 from 'assets/img/axe-76.png';

import ACM from 'assets/img/stock/ACM.png';
import Gaposa from 'assets/img/stock/Gaposa.png';


import RideauButee from 'assets/img/rideau-butee.png';
import RideauSansButee from 'assets/img/rideau-sans-butee.png';

import LameFinaleSerrure from 'assets/img/lame-finale-serrure.png';
import RideauSabot from 'assets/img/rideau-sabot.jpg';

export const SabotRM = [
	{
		id: 'RMASABOT',
		label: 'Avec sabot',
		value: 'avec sabot',
		nextStep: false,
	},
	{
		id: 'RMESSABOT',
		label: 'sans sabot',
		value: 'sans sabot',
		nextStep: false,
	},
];

export const LameFRM = [
	{
		id: 'RMAS',
		label: 'Avec serrure',
		value: 'avec serrure',
		nextStep: false,
	},
	{
		id: 'RMESS',
		label: 'sans serrure',
		value: 'sans serrure',
		nextStep: false,
	},
];

export const EnroulementRM =  [
		{
			id: 'RMINT',
			label: 'Intérieur',
			value: 'intérieur',
			imageUrl: EnroulementInterieur,
			nextStep: false,
			description:
				'- Enroulement du tablier côté intérieur du local, Solution privilégiée pour une meilleure protection du mécanisme.' 
		},
		{
			id: 'RMEXT',
			label: 'Extérieur',
			value: 'extérieur',
			imageUrl: EnroulementExterieur,
			nextStep: false,
			description:
				'- Enroulement du tablier côté extérieur, Adapté aux configurations où l’encombrement intérieur doit être limité.' 
		},
	]
export const coulisseRM = [
	{
		id: 'sansCOUL',
		label: 'Sans coulisses',
		value: 'Sans coulisses',
		nextStep: false,
	},
	{
		id: 'avecCOUL',
		label: 'Avec coulisses',
		value: 'Avec coulisses',
		nextStep: false,
	},
];

export const BoiteRM = [
	{
		id: 'Câble de débrayage',
		label: 'Câble de débrayage',
		value: 'Câble de débrayage',
		imageUrl: CableDebrayage,
		nextStep: false,
		description:
			'- Avec câble de débrayage permettant une manœuvre manuelle du rideau en cas de coupure de courant.',
	},
	{
		id: 'Boîte à bouton',
		label: 'Boîte à bouton',
		value: 'Boîte à bouton',
		imageUrl: BoiteBouton,
		nextStep: false,
		description:
			'- Avec boîte à bouton murale offrant une commande simple et rapide du rideau.',
	},
	{
		id: 'Boîte à clé',
		label: 'Boîte à clé',
		value: 'Boîte à clé',
		imageUrl: BoiteCle,
		nextStep: false,
		description:
			'- Avec boîte à clé sécurisée permettant l’ouverture et la fermeture par clé.',
	},
	{
			id: 'Armoire',
			label: 'Armoire + télécommande (émetteur - récepteur)',
			value: 'Armoire + télécommande (émetteur - récepteur)',
			description: '- Armoire de commande avec télécommande (émetteur / récepteur).',
		},
		{
			id: 'Cornière de renfort',
			label: 'Cornière de renfort',
			value: 'Cornière de renfort',
			description: '- Ajout d’une cornière de renfort.',
		},
	{
		id: 'Boîte à clé avec système de débrayage',
		label: 'Boîte à clé avec système de débrayage',
		value: 'Boîte à clé avec système de débrayage',
		imageUrl: BoiteCleCableDebrayage,
		nextStep: false,
		description:
			'- Avec boîte à clé intégrant un système de débrayage pour une utilisation manuelle en cas de panne.',
	},
	// ****
	
];

export const BoiteManuelle = [
	
	{
			id: 'RMAS',
			label: 'Avec serrure',
			value: 'équipée d’une serrure',
			imageUrl: LameFinaleSerrure,
			description: '- Lame finale équipée d’une serrure, Permet le verrouillage du rideau métallique et renforce la sécurité du local.\n' 
		},
		{
					id: 'RMASABOT',
					label: 'Avec sabot',
					value: 'Avec sabot',
					imageUrl: RideauSabot,
					description: '- Présence d’un sabot en partie basse du tablier. Permet une meilleure protection du rideau et un appui renforcé au sol lors de la fermeture.\n'
				},
{
					id: 'RMASABOT',
					label: 'Avec butée',
					value: 'Avec butée',
					imageUrl: RideauButee,
					description: '- Configuration avec butées limitant la course du tablier et assurant un arrêt sécurisé en position basse.',
				},
];

export const AxeMotoriseRM = [
	{
		id: 'centrale_monophasé',
		label: 'Centrale monophasée',
		value: 'central monophasé',
		imageUrl: MoteurCentrale,
		description:
			'- Motorisation centrale monophasée offrant une ouverture et une fermeture fluides avec une utilisation simple.',
	},
	{
		id: 'centrale_triphasé',
		label: 'Centrale triphasée',
		value: 'central triphasé',
		imageUrl: MoteurCentrale,
		description:
			'- Motorisation centrale triphasée assurant un fonctionnement puissant, stable et fiable pour une utilisation intensive.',
	},
	{
		id: 'tubulaire',
		label: 'Tubulaire',
		value: 'tubulaire',
		imageUrl: MoteurTubulaire,
		description:
			'- Motorisation tubulaire intégrée à l’axe d’enroulement garantissant un fonctionnement discret et une intégration compacte.',
	},
	{
		id: 'latérale',
		label: 'Latérale',
		value: 'latéral',
		imageUrl: MoteurLaterale,
		description:
			'- Motorisation latérale montée en bout d’axe permettant une transmission efficace et un accès facilité pour la maintenance.',
	},
];


export const AxeManuelRM = [
	{
		id: '50',
		value: '50',
		imageUrl: Axe50,
		nextStep: false,
		description:
			'- Diamètre d’axe 50 mm permettant un enroulement fluide du tablier.',
	},
	{
		id: '60',
		value: '60',
		imageUrl: Axe60,
		nextStep: false,
		description:
			'- Diamètre d’axe 60 mm offrant une bonne stabilité et une rotation régulière du tablier.',
	},
	{
		id: '76',
		value: '76',
		imageUrl: Axe76,
		nextStep: false,
		description:
			'- Diamètre d’axe 76 mm assurant un enroulement homogène et une meilleure tenue mécanique.',
	},
	{
		id: '133',
		value: '133',
		imageUrl: Axe133,
		nextStep: false,
		description:
			'- Diamètre d’axe 133 mm permettant de réduire les efforts sur le mécanisme lors de l’enroulement.',
	},
	{
		id: '168',
		value: '168',
		imageUrl: Axe168,
		nextStep: false,
		description:
			'- Diamètre d’axe 168 mm optimisant la longévité du mécanisme et la régularité de fonctionnement.',
	},
];

export const platBombeRM = [
	{
		id: 'sansPB',
		label: 'Sans plats bombés',
		value: 'Sans plats bombés',
		imageUrl: SansPlatBombee,
		nextStep: false,
		description:
			'- Configuration sans plats bombés, adaptée aux installations standards sans contrainte particulière.',
	},
	{
		id: 'avecPB',
		label: 'Avec plats bombés',
		value: 'Avec plats bombés',
		imageUrl: PlatBombee,
		nextStep: false,
		description:
			'- Configuration avec plats bombés améliorant la rigidité et la tenue du tablier.',
	},
];


export const bobineRM = [
	{
		id: '2',
		label: '2',
		value: '2',
		imageUrl: Bobines2,
		nextStep: false,
		description:
			'- Nombre de bobines 2 permettant un guidage simple et régulier du tablier.',
	},
	{
		id: '4',
		label: '4',
		value: '4',
		imageUrl: Bobines4,
		nextStep: false,
		description:
			'- Nombre de bobines 4 assurant une meilleure répartition des efforts lors de l’enroulement.',
	},
	{
		id: '6',
		label: '6',
		value: '6',
		imageUrl: Bobines6,
		nextStep: false,
		description:
			'- Nombre de bobines 6 améliorant la stabilité et la régularité du fonctionnement.',
	},
	{
		id: '8',
		label: '8',
		value: '8',
		imageUrl: Bobines8,
		nextStep: false,
		description:
			'- Nombre de bobines 8 optimisant le maintien du tablier et la durabilité du mécanisme.',
	},
];


export const sortieCableRM = [
	{
		id: 'CVE',
		label: 'droite vue extérieur',
		value: 'droite vue extérieur',
		nextStep: false,
	},
	{
		id: 'DVI',
		label: 'droite vue intérieur',
		value: 'droite vue intérieur',
		nextStep: false,
	},
	{
		id: 'GVE',
		label: 'gauche vue extérieur',
		value: 'gauche vue extérieur',
		nextStep: false,
	},
	{
		id: 'GVI',
		label: 'gauche vue intérieur',
		value: 'gauche vue intérieur',
		nextStep: false,
	},
];

export const PoseRM = [
	{
		id: 'POSEAPP',
		label: 'Pose en applique',
		value: 'Pose en applique',
		imageUrl: PoseApplique,
		nextStep: false,
		description:
			'- Pose en applique réalisée en façade permettant une installation simple et une couverture totale de l’ouverture.',
	},
	{
		id: 'POSETUNNEL',
		label: 'Pose en tunnel',
		value: 'Pose en tunnel',
		imageUrl: PoseTunnel,
		nextStep: false,
		description:
			'- Pose  en tunnel réalisée à l’intérieur du tableau offrant un rendu discret et aligné avec l’ouverture.',
	},
	{
		id: 'POSEENCAST',
		label: 'Pose encastrée',
		value: 'Pose encastrée',
		imageUrl: PoseEncastre,
		nextStep: false,
		description:
			'- Pose encastrée intégrée dans la maçonnerie permettant une finition esthétique et une intégration optimale.',
	},
];


export const MesureLargeur = [
	{
		id: 'RMFN',
		label: 'FINI',
		value: 'FINI',
		nextStep: false,
			description: '- Mesure selon largeur : FINI'

	},
	{
		id: 'RME',
		label: 'DC',
		value: 'DC',
		nextStep: false,
			description: '- Mesure selon largeur : D.C'

	},
];

export const MesureHauteur =[
		{
			id: 'RMEC',
			label: 'Enroulement compris',
			value: 'enroulement compris',
			nextStep: false,
			description: '- Mesure selon hauteur : Enroulement compris'

		},
		{
			id: 'RMPE',
			label: '+E',
			value: '+E',
			nextStep: false,
			description: '- Mesure selon hauteur : +E'

		},
	]
export const coffreRM = [
	{
		id: 'sansCOFF',
		label: 'Sans coffre',
		value: 'Sans coffre',
		nextStep: false,
	},
	{
		id: 'avecCOFF',
		label: 'Avec coffre',
		value: 'Avec coffre',
		nextStep: false,
	},
];


export  const marqueMoteur = [
		{
			id: 'GAPOSA',
			label: 'Gaposa',
			value: 'Gaposa',
			imageUrl: Gaposa, // (optionnel)
			nextStep: false,
		},
		{
			id: 'ACM',
			label: 'ACM',
			value: 'ACM',
			imageUrl: ACM, // (optionnel)
			nextStep: false,
		},
	]


export const Butee = [
	{
		id: 'RMSBUTEE',
		label: 'Sans butées',
		value: 'sans butées',
		imageUrl: RideauSansButee,
		nextStep: false,
		description:
			'- Configuration sans butées, le tablier descend librement jusqu’au sol selon l’installation.',
	},
	{
		id: 'RMABUTEE',
		label: 'Avec butées',
		value: 'avec butées',
		imageUrl: RideauButee,
		nextStep: false,
		description:
			'- Configuration avec butées limitant la course du tablier et assurant un arrêt sécurisé en position basse.',
	},
];

		
export const lamesRM= [
		{
			id: 'Lames_cobra',
			label: 'Cobra',
			value: 'lames cobra',
			imageUrl: LameCobra,
			description:
				'- Type de lames ajourées de forme Cobra, offrant une bonne visibilité tout en assurant la sécurité. Adaptées aux vitrines et commerces nécessitant une protection avec transparence.' 
				
		},
		{
			id: 'Lames_pleines',
			label: 'Pleines',
			value: 'lames pleines',
			imageUrl: LamePleine,
			description:
				'- Type de lames opaques pleines assurant une occultation totale et un niveau de sécurité élevé. Recommandées pour les locaux nécessitant une protection renforcée.' 
				
		},
		{
			id: 'Lames_polycarbonate',
			label: 'Polycarbonate',
			value: 'lames polycarbonate',
			imageUrl: LamePolycarbonate,
			description:
				'- Type de lames transparentes en polycarbonate, Permettent une visibilité totale tout en conservant une bonne résistance aux chocs.' 
				
		},
		{
			id: 'Lames_micro_perforees',
			label: 'Micro-perforées',
			value: 'lames micro perforees',
			imageUrl: LameMicroperforee,
			description:
				'- Type de lames micro-perforées offrant un équilibre entre visibilité, aération et protection. Conviennent aux commerces recherchant un compromis entre sécurité et luminosité.' 		
		},
	]